import {runImpersonationMiddleware} from '@shared-utils/router/middlewares/impersonationMiddleware'
import {setPageTitle} from '@shared-utils/helpers'

export const middlewareAccessControlAndTitle = ({...args}) => {
  const {to, authenticationStore, accessRules} = args

  setPageTitle(to)

  if (!to.meta.access) {
    return null
  }

  const hasAccess = to.meta.access.every(rule => accessRules[rule](authenticationStore, to))

  return hasAccess ? null : {name: 'home'}
}
export const middlewareImpersonationAndAccessControlAndSetTitle = async ({...args}) => {
  const {to, authenticationStore, router, accessRules} = args
  const isImpersonated = await runImpersonationMiddleware(to, authenticationStore, router)

  if (!isImpersonated) {
    return false
  }

  await authenticationStore.loadAuthUserInfo()

  const accessRoute = middlewareAccessControlAndTitle({to, authenticationStore, accessRules})

  if (accessRoute) {
    return accessRoute
  }

  return {impersonated: true}
}
